import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const TimerIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 48 48" width="48" height="48" {...props}>
    <rect width="48" height="48" rx="24" fill="#E9E9E6" />
    <path
      d="M33.6666 23.9999C33.6666 29.3387 29.3387 33.6666 23.9999 33.6666C18.6612 33.6666 14.3333 29.3387 14.3333 23.9999C14.3333 18.6612 18.6612 14.3333 23.9999 14.3333C29.3387 14.3333 33.6666 18.6612 33.6666 23.9999Z"
      stroke="#747778"
      strokeWidth="2"
    />
    <path d="M24 12L24 14.2456" stroke="#747778" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M23.4385 25.1929L27.4385 21.1929"
      stroke="#747778"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M30.6665 17.3333L31.9998 16" stroke="#747778" strokeWidth="2" strokeLinecap="round" />
  </IconWrapper>
);

export default TimerIcon;
